import { createContext } from 'react';
import { OrganizationSetupContextType } from '../../types/organization';

const OrganizationSetupContext = createContext<OrganizationSetupContextType | null>(null);

export default OrganizationSetupContext;
